import algoliasearch from 'algoliasearch';

export default {
    data() {
        return {
            previousPickupLocationId: null,
            dropoffLocations: [],
        };
    },

    watch: {
        pickupLocation(location) {
            if (location === null || location.provider === 'CTR') {
                return this.$store.dispatch('setDropoffLocation', null);
            }

            if (location.dropoff_locations) {
                let locations = location.dropoff_locations.locations.slice(0);

                if (locations.length <= 1 && locations[0] === location.id) {
                    return;
                }

                locations.unshift(location.id);
                algoliasearch(this.searchOptions.appId, this.searchOptions.apiKey)
                    .initIndex(`${this.searchOptions.prefix}locations`)
                    .getObjects(locations.map(e => 'WoS_' + e), (err, content) => {
                        this.$store.dispatch('setDropoffDifferent', true);
                        this.dropoffLocations = content.results;
                    });

                // Keep the dropoff location for one-way quotes when updating the dates.
                // Should check that previous pickup location has not changed,
                // and if it has changed, then do not keep the dropoff location and continue to set the new one
                if (
                    this.dropoffLocation &&
                    (this.previousPickupLocationId === location.id)
                ) {
                    this.$store.dispatch('setDropoffLocation', this.dropoffLocation);
                    return;
                }

                // Set the previous pickup location to check if the dropoff location should remain as is
                // or change on subsequent pickup changes
                this.previousPickupLocationId = location.id;

                this.$store.dispatch('setDropoffLocation', location);
            }
        },
    },

    methods: {
        updateDropoffLocation(e) {
            this.dropoffLocations.map(locationItem => {
                if (locationItem.id == e.target.value) {
                    this.$store.dispatch('setDropoffLocation', locationItem);
                }
            });
        },
    },
};
